import React from 'react';
import { TitleBase, StyledBase } from '../index';

const Styled = StyledBase.withComponent('h2');

const Subtitle = ({ className, children, ...rest }) => (
  <Styled className={className} {...rest}>
    <TitleBase>{children}</TitleBase>
  </Styled>
);

export default Subtitle;



// WEBPACK FOOTER //
// ./src/components/Title/components/Subtitle.js